<template>
  <v-card :style="backOpacity">
    <v-card-title>自動スクロール機能 AutoScroll.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-select
                label="リンク"
                v-model="returnData.init"
                :items="paths"
                item-text="display"
                item-value="path"
                required
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-show="showButton"
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    cols: String,
    rule: String,
    init: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        cols: this.cols,
        rule: this.rule,
        init: this.init,
      },
      showButton: false,
      backOpacity: "opacity: 1",
      //
      paths: [],
      //
      validation: {},
    };
  },
  async mounted() {
    //送信ボタンのカクツキ防止
    setTimeout(() => {
      this.showButton = true;
    }, 500);

    await this.getInit();
    //初期処理
  },
  methods: {
    async getInit() {
      //ルーティング情報の格納
      this.routes = await api.getRouter();
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit("clickSubmit", this.returnData);
      }
    },
    /* false undefined の時にfalseを返す。trueや"true"はtrueを返す */
    nullCheck(value) {
      let checkFlag = true;
      switch (value) {
        case "":
        case "undefined":
        case null:
        case undefined:
        case false:
          checkFlag = false;
      }

      return checkFlag;
    },
  },
};
</script>
